import React, { useEffect, useState } from "react";
import {
	Button,
	Container,
	Grid,
	Toolbar,
	Alert,
	Tooltip,
} from "@mui/material";
import WorkIcon from "@mui/icons-material/Work";
import AddIcon from "@mui/icons-material/Add";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Table from "../../components/table/Table";
import { Widget } from "../../components/widget/Widget";

import FullScreenDialog from "../../components/manage_campaign/modal";
import { useDispatch, useSelector } from "react-redux";
import {
	getAllAssociations,
	getUnassignedCampaigns,
} from "../../redux/actions/campaign.actions";
import AssignCampaign from "./AssignCampaign";
import { setAlert } from "../../redux/actions/alert.actions";
import CreateIcon from '@mui/icons-material/Create';
import StatsCard from "../../components/Comman/cards";
import CardWithButton from "../../components/Comman/button-new";

const ClientCampaigns = () => {
	const { campaigns, assignedCampaigns, updateAssignedCampaigns } = useSelector(
		(state) => state.campaignReducer
	);


	const dispatch = useDispatch();
	const [rows, setRows] = useState([]);


	useEffect(() => {
		const filteredRow = Array.isArray(assignedCampaigns) ? assignedCampaigns.map((item) => ({
			...item,
			id: item.client_org_campaigns_id,
			campaign_id: item.campaign_id,
			campaign_name: item.name,
			client_id: item.client_id,
			client_name: item.client_name,
			coc: item.id
		})) : [];
		setRows(filteredRow);
	}, [assignedCampaigns]);


	const [alertMessage, setAlertMessage] = useState("");
	const [alertType, setAlertType] = useState("Success");
	const [openModal, setOpenModal] = useState(false);
	const [isEdit, setIsEdit] = useState(false);
	const [campaigndata, setCampaignData] = useState("");

	useEffect(() => {
		dispatch(getAllAssociations());
		dispatch(getUnassignedCampaigns()); // vms api
	}, []);

	useEffect(() => {
		if (updateAssignedCampaigns && updateAssignedCampaigns?.success === true) {
			dispatch(getAllAssociations());
		}
	}, [updateAssignedCampaigns])




	const handleModal = (value) => {
		value ? setOpenModal(value) : setOpenModal(!openModal);
		setIsEdit(false);
	};

	const handleAlert = (value) => {
		setAlert(value);
	};

	const handleView = (value) => {
		setCampaignData(value)
		setOpenModal(true);
		setIsEdit(true)
	};

	const columns = [
		{ field: "id", headerName: "ID", flex: 0.5 },
		{
			field: "client_name",
			headerName: "Client Name",
			flex: 1,
			editable: false,
		},
		{
			field: "campaign_name",
			headerName: "Campaign Name",
			flex: 1,
			editable: false,
		},

		{
			field: "actions",
			headerName: "Update",
			flex: 0.5,
			sortable: false,
			renderCell: (params) => (
				<Box>
					<Tooltip title='Update'>
						<IconButton onClick={() => handleView(params.row)}>
							<CreateIcon color="success"/>
						</IconButton>
					</Tooltip>
				</Box>
			),
		},
	];


	const active = Array.isArray(assignedCampaigns) ? assignedCampaigns
		.map((item) => item.status)
		.filter((item) => item === 1) : ""

	return (
		<Container style={{
			border: "1px solid rgba(0, 0, 0, 0.1)",
			padding: "20px 0px 20px 20px",
			width: "98%",
			marginBottom: "5%"
		}}
			className="shadow-md bg-white rounded ">
			<Grid container direction='column' spacing={5}>
				<Grid
					container
					Item
					direction='row'
					justifyContent='space-evenly'
					alignItems='center'>
					<StatsCard heading="TOTAL CAMPAIGNS" icon={<WorkIcon />} content={assignedCampaigns.length} />
					<StatsCard heading="ACTIVE CAMPAIGNS" icon={<WorkIcon />} content={active.length} />
				</Grid>
				<Grid item>
					<CardWithButton
						title="Assign Campaigns"
						className=""
						buttonLabel="Assign Campaigns"
						buttonIcon={<AddIcon />}
						buttonClick={() => handleModal(true)}
					/>
				</Grid>
				<Grid item>
					<Table rows={rows} columns={columns} />
				</Grid>
			</Grid>
			{openModal && (
				<AssignCampaign
					handleModal={handleModal}
					openModal={openModal}
					handleAlert={handleAlert}
					campaigns={campaigns}
					campaigndata={campaigndata}
					isEdit={isEdit}
				/>
			)}
		</Container>
	);
};

export default ClientCampaigns;
